<template>
  <modal
    :name="modalName"
    transition="none"
    @before-open="beforeOpen"
    :width="590"
    :height="'auto'"
    :clickToClose="false"
  >
    <div class="container">
      <div class="content">
        <div class="msg" v-html="info.msg"></div>
        <div class="pic" v-if="info.type" >
          <div class="pic__item" v-if="info.type === 'solo'">
            <!-- <img src="../../../static/svg/solo_vip.png" alt=""> -->
            <vipCard :tip="info.soloTip"></vipCard>
          </div>

          <div class="pic__item" v-if="info.type === 'vip'">
            <!-- <img src="../../../static/svg/normalvip.png" alt=""> -->
            <vipCard vipLevel="solo"></vipCard>
          </div>
          <div
            class="pic__item"
            v-if="info.type === 'vip'"
            style="margin-left: 50px"
          >
            <!-- <img src="../../../static/svg/teamvip.png" alt=""> -->
            <vipCard vipLevel="vip"></vipCard>
          </div>

          <div class="pic__item" v-if="info.type === 'vip.s'">
            <!-- <img src="../../../static/svg/teamvip.png" alt=""> -->
            <vipCard vipLevel="vip.s"></vipCard>
          </div>
        </div>
      </div>
      <div class="footer" v-if="info.secondaryBtnType === 'package'">
        <a
          :href="'/' + info.package"
          :target="'_blank'"
          @click="
            showPaymentDialog();
            clickToClose();
          "
        >
          <div class="button button-package">购买资源包</div>
        </a>
        <a
          :href="'/' + info.target"
          :target="'_blank'"
          @click="
            showPaymentDialog();
            clickToClose();
          "
        >
          <div class="button">开通高级会员</div>
        </a>
      </div>
      <div class="footer" v-if="info.secondaryBtnType === 'manage'">
        <a :href="'/workplace/dashboard/animation/project'" :target="'_blank'" @click="clickToClose()">
          <div class="button">去删除作品项目</div>
        </a>
        <a :href="'/' + info.target" :target="'_blank'" @click="clickToClose()">
          <div class="button">{{ info.btnText }}</div>
        </a>
      </div>
      <div class="footer" v-if="!info.secondaryBtnType">
        <a v-if="info.target"
          :href="'/' + info.target"
          :target="'_blank'"
          @click="
            showPaymentDialog();
            clickToClose();
          "
        >
          <div class="button">{{ info.btnText }}</div>
        </a>
        <div class="button" @click="clickToClose()" v-else>{{ info.btnText }}</div>
      </div>

      <a
        v-if="info.bottomLink"
        class="bottom-link"
        :target="info.bottomLinkTarget"
        :href="info.bottomLink"
        >{{ info.bottomLinkText}}</a
      >

      <div v-if="info.hasCloseBtn" class="close-btn" @click="clickToClose()">
        <i class="icon-popup-close"></i>
      </div>
    </div>
  </modal>
</template>

<script>
import vipCard from '@/components/widgets/vipCard';

export default {
  props: {
    modalName: { default: 'vipDialog' }
  },
  components: {
    vipCard
  },
  data () {
    let infoDef = {
      msg: '',
      type: 'solo', // solo | vip
      target: '', // vipsolo | vip
      btnText: '立即开通',
      secondaryBtnType: '', // package | manage
      bottomLink: '',
      bottomLinkTarget: '_blank',
      bottomLinkText: '',
      hasCloseBtn: true,
      soloTip: ''
    }
    return {
      info: {
        ...infoDef
      },
      infoDefault: {
        ...infoDef
      }
    };
  },
  created () {

  },
  methods: {
    clickToClose () {
      this.$modal.hide(this.modalName);
    },
    beforeOpen ({ params } = {}) {
      this.info = {
        ...this.infoDefault,
        ...params
      };
      switch (this.info.trackingSource) {
        case 'watermark':
          this.saveLocal({
            routename: 'tool',
            page: '编辑器-无水印-会员引导弹窗'
          });
          break;
        case 'hd':
          this.saveLocal({
            routename: 'tool',
            page: '编辑器-高清画质-会员引导弹窗'
          });
          break;
        case 'AIVoice':
          this.saveLocal({
            routename: 'tool',
            page: '编辑器-AI配音-会员引导弹窗'
          });
          break;
        default:
          this.saveLocal({
            routename: 'tool',
            page: '编辑器-会员升级-会员引导按钮'
          });
          break;
      }
      this.$util.localStorage.set('saPurchaseSource', {
        fullPath: '/tool'
      });
    },
    saveLocal (payload) {
      this.$util.localStorage.set('sensorWebPurchaseVipSource', {
        val: payload,
      });
      this.$util.localStorage.set('sensorWebPayVipSource', {
        val: payload,
      });
    },
    goPackage () {
      this.$bus.emit('payPriceEvent_vue', { type: true });
      this.clickToClose();
      this.showPaymentDialog();
    },
    goWatermark () {

    },
    showPaymentDialog () {
      let name = 'vipPayment' ;
      let evName = this.modalName === 'subtitleVipDialog' ? 'subtitlePopup' : 'FeaturesPop_vue'
      this.$bus.emit(evName, {
        name,
        msg: '请在相应的付款页面进行操作',
        btnClose: '遇到问题',
        btnMsg: '付款成功',
        fs: 'payPriceEvent_vue',
        msgType: 2,
        type: 2
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.v--modal-overlay {
  background: rgba(0, 0, 0, 0.6);
}
.container {
  position: relative;
  width: 590px;
  // height: 490px;
  margin: auto;
  padding-top: 28px;
  padding-bottom: 56px;
  background-color: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;
  text-align: center;
}

.content {
  min-height: 44px;
}

.msg {
  width: 370px;
  min-height: 50px;
  margin: 0 auto;
  padding: 40px 0 20px;
  font-family: Microsoft Yahei;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  letter-spacing: 0;
  color: #474261;
}

.pic {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  height: 256px;
  padding: 0 75px;

  &__item {
    width: 200px;
    height: 225px;
  }
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  & > a {
    margin-left: 36px;
  }
  & > a:first-child {
    margin-left: 0;
  }
}

.button {
  width: 160px;
  height: 40px;
  border-radius: 8px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  background-color: #5778fb;
  text-decoration: none;
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
}

.button-package {
  margin-right: 85px;
}

.bottom-link {
  display: block;
  margin-top: 5px;
  color: #5778fb;

  &:visited {
    color: #5778fb;
  }
}
.a {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/vipDialog.vue